import CampaignsCards from '../../components/Campaigns/CampaignsCards';
import CampaignsPageCommon from '../../components/Campaigns/CampaignsPageCommon';

const CampaignsPage = () => {
  return <CampaignsPageCommon type="simple" Cards={CampaignsCards} />;
};

export default CampaignsPage;
